import { render, staticRenderFns } from "./tag-filter.vue?vue&type=template&id=124ec0b3&"
import script from "./tag-filter.vue?vue&type=script&lang=js&"
export * from "./tag-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Umbraco\\Upgrade\\CareFirst\\v16\\Website\\CarersFirst.Shared.FrontEnd\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124ec0b3')) {
      api.createRecord('124ec0b3', component.options)
    } else {
      api.reload('124ec0b3', component.options)
    }
    module.hot.accept("./tag-filter.vue?vue&type=template&id=124ec0b3&", function () {
      api.rerender('124ec0b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/vue-components/common/listing/tag-filter.vue"
export default component.exports